import { createFileRoute, Navigate } from '@tanstack/react-router'
import React from 'react'
import { AdminDashboard } from '../dashboard/components/admin-dashboard'
import { dashboardQuery } from '../dashboard/dashboard'
import { useAuth } from '../auth'
import { CustomerDashboard } from '../dashboard/components/customer-dashboard'
import { useTitle } from '../hooks/use-title'
import { useTranslation } from 'react-i18next'

export const Route = createFileRoute('/_auth/_main/dashboard')({
    validateSearch: dashboardQuery,
    component: DashboardComponent,
})

function DashboardComponent() {
    const search = Route.useSearch()
    const { user, websitePlan } = useAuth()
    const { t } = useTranslation()

    useTitle(t('Dashboard'))

    if (user?.role === 'admin') {
        return <AdminDashboard {...search} />
    }

    // The Website plan is about the website first; its home is the websites.
    if (websitePlan) {
        return <Navigate to="/websites" />
    }

    return <CustomerDashboard />
}
